import { AuditAudio, DateTimeStr, Station, toDateTimeStr } from '@mi-front/core';
import moment from 'moment';
import { apiClient } from '../../../../api';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { ListingView } from '../../../../core/reports/components/ListingView';
import { ListingType } from '../../../../core/reports/types';
import { AudiosListForm } from './form';
import { AudiosListResult } from './result';

interface Props {
  readonly station: Station;
}

export type AudiosListing = ListingType<
  { from: DateTimeStr; to: DateTimeStr; customId: { customId: string }[] },
  AuditAudio
>;

export function AudiosListView(p: Props) {
  const tz = useTimezone();

  return (
    <ListingView<AudiosListing>
      defaultValues={{
        from: toDateTimeStr(moment().tz(tz).startOf('day').toISOString()),
        to: toDateTimeStr(moment().tz(tz).endOf('day').toISOString()),
        customId: [],
        sort: 'createdAt desc',
      }}
      queryParamsTransform={{
        customId: {
          parse: (input) => input.split(',').map((customId) => ({ customId })),
          serialize: (input: { customId: string }[]) => input.map((v) => v.customId).join(','),
        },
      }}
      reportFn={async (values) => {
        return apiClient.audit.fetchAudios({
          ...values,
          page: values.pageIndex,
          stationId: p.station.slug,
          filter: {
            customId: values.customId?.length
              ? values.customId.map(({ customId }) => customId)
              : undefined,
            from: values.from,
            to: values.to,
          },
        });
      }}
      Form={AudiosListForm}
      Result={AudiosListResult}
    />
  );
}
